import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ImportarIrcp } from '../models/importar-ircp.model';
import { ImportarIrcpService } from '../services/importar-ircp.service';

@Component({
  selector: 'app-importar-ircp-modal',
  templateUrl: './importar-ircp-modal.component.html',
  styleUrls: ['./importar-ircp-modal.component.scss']
})
export class ImportarIrcpModalComponent extends BaseFormComponent<ImportarIrcp> implements OnInit {

  modalContent: ImportarIrcp;
  selectedFile: File | null = null;
  modalRef?: BsModalRef;

  @ViewChild('modal') modal: TemplateRef<any>;

  constructor(
    public activatedRoute: ActivatedRoute,
    private myService: ImportarIrcpService,
    private modalService: BsModalService,
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.loaded();
  }

  initForm() {
    this.form = new FormGroup({
      file: new FormControl(),
    });
  }

  openModal(data) {
    this.initForm();
    this.modalContent = data;
    this.modalRef = this.modalService.show(this.modal);
  }

  closeModal() {
    this.modalRef?.hide();
    this.form.reset();
    this.modalContent = null;
  }

  sendFile() {
    if (this.form.valid) {
      this.loading();
      let typeId = this.modalContent?.id;
      this.addSub(
        this.myService.uploadFile(this.modalContent?.id, this.selectedFile).subscribe({
          next: (res) => {
            this.closeModal();
            this.msgSuccess(res?.message);
            if (res.csv) {
              const blob = new Blob([res.csv], { type: 'application/csv' });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = 'out_import_' + typeId + '.csv';
              a.click();
            }
            this.loaded();
          },
          error: (error) => {
            this.closeModal();
            if (error.status === 500) {
              this.msgError(error?.error?.message)
              if (error?.error?.csv) {
                const blob = new Blob([error?.error?.csv], { type: 'application/csv' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'out_import_' + typeId + '.csv';
                a.click();
              }
            }
            this.loaded();
          },
        })
      );
    }
    else {
      this.markAsDirty();
    }
  }

  onFileSelected(event: any): void {
    this.selectedFile = event?.target?.files[0];
  }

}
